import { render, staticRenderFns } from "./MyUploadFileFormItem.vue?vue&type=template&id=7ff2252f&scoped=true&"
import script from "./MyUploadFileFormItem.vue?vue&type=script&lang=js&"
export * from "./MyUploadFileFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2252f",
  null
  
)

export default component.exports